interface Option {
  value: string;
  label: string;
}

interface FilterChipsProps {
  label: string;
  options: Option[];
  selected: string[];
  onToggle: (value: string) => void;
}

export default function FilterChips({ label, options, selected, onToggle }: FilterChipsProps) {
  if (options.length === 0) return null;
  return (
    <div className="flex flex-col gap-2 py-3 sm:flex-row sm:items-start">
      <span className="w-16 shrink-0 pt-0.5 text-sm text-foreground-500">{label}</span>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const active = selected.includes(option.value);
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onToggle(option.value)}
              className={`whitespace-nowrap rounded-md border px-3 py-1 text-sm transition-colors ${
                active
                  ? "border-secondary-500 bg-secondary-500 text-background-50"
                  : "border-background-200 bg-background-50 text-foreground-600 hover:border-secondary-300 hover:text-secondary-600"
              }`}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}